// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-fill[data-v-e0059b82] {\n    background-color: var(--color-white);\n    margin-bottom: 16px;\n    margin-top: 60px;\n    max-width: 263px;\n}\n.btn-findmore[data-v-e0059b82] {\n    margin: 30px 0;\n}\n@media (min-width: 992px) {\n.btn-findmore[data-v-e0059b82] {\n        width: 263px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
